<div class="prompts">
  @for (prompt of prompts(); track prompt) {
    <div class="prompt" (click)="handlePromptClick(prompt)">
      {{ prompt }}
    </div>
  }
</div>
